import React, {ReactNode} from 'react';
import {AppBar, IconButton, Toolbar, Typography} from "@mui/material";

export type NavigationBarProps = {
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    leftIconClick?: () => void;
    rightIconClick?: () => void;
    title: string;
};

const NavigationBar: React.FC<NavigationBarProps> = (props) => {
    return (
        <AppBar position="static">
            <Toolbar>
                <IconButton edge="start" color="inherit"
                            onClick={() => props.leftIconClick && props.leftIconClick()}>
                    {props.leftIcon}
                </IconButton>
                <Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>
                    {props.title}
                </Typography>
                <IconButton edge="end" color="inherit"
                            onClick={() => props.rightIconClick && props.rightIconClick()}>
                    {props.rightIcon}
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};
export default NavigationBar;